<template>
    <v-container fluid>
        <v-row>
            <v-col cols="7">

            <img src="../assets/img/community.png"  width="100%"/>
        </v-col>
        <v-col cols="5" class="pt-10">
            <h1 class="community-header mt-10 color">Help each other,<br />Heal Together!</h1>
            <p class="lead mt-5 title-pg">Get to Know and talk to similiar people on Medinspire and learn from there experiences!
                Become a Community!
            </p>
        </v-col>
        </v-row>
        
    </v-container>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.community-header{
    font-size:3rem !important;
}
.color{
    color:#32c788;
}
</style>

